import React from 'react';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';

import { CashierFlowType } from '../../types/Cashier';
import Deposit from '../Deposit/Deposit';
import FirstLoader from '../FirstLoader/FirstLoader';
import PaymentVerification from '../PaymentVerification/PaymentVerification';
import RMF from '../RMF/RMF';

import Signup from './Signup';

const SignupWizard: React.FC = () => (
  <StarsWizard flow={[Signup, RMF, Deposit]} loader={<FirstLoader />}>
    <Signup />
    <RMF />
    <Deposit />
    <PaymentVerification cashierFlow={CashierFlowType.FirstDeposit} />
  </StarsWizard>
);

export default SignupWizard;
